import { Typography } from '@mui/material';
import { Field } from 'formik';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { PRIMARY_BLUE } from '../../../../Constants/Colors.constants';
import { Checkbox, FormControl, Link as MuiLink } from '../../../../UIKit';
import { makeStyles } from '~/UIKit/Style';

const useStyles = makeStyles({
  onboardingTermsAndConditionsInputContainer: {
    marginTop: 5,
  },

  onboardingTermsAndConditionsInput: {
    width: 300,
    '& >.MuiSelect-selectMenu': {
      display: 'flex',
      alignItems: 'center',
    },
  },

  onboardingTermsAndConditionsTermsContainer: {
    marginTop: 30,
  },

  onboardingTermsAndConditionsTerms: {
    display: 'flex',
    alignItems: 'center',

    '&>div>a': {
      color: PRIMARY_BLUE,
    },
  },

  onboardingTermsAndConditionsCheckbox: {
    width: 40,
    height: 40,
  },

  onboardingTermsAndConditionsText: {
    fontSize: '13px',
  },
});

export const OnboardingTermsAndConditions = ({ disabled = false }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <FormControl
      className={`${classes.onboardingTermsAndConditionsInputContainer} ${classes.onboardingTermsAndConditionsTermsContainer}`}
    >
      <div className={classes.onboardingTermsAndConditionsTerms}>
        <Field
          component={Checkbox}
          name="termsAndConditions"
          data-testid="termsAndConditions"
          disabled={disabled}
          className={classes.onboardingTermsAndConditionsCheckbox}
        />
        <Typography className={classes.onboardingTermsAndConditionsText}>
          <Trans
            i18nKey="signup.termsAndConditions"
            values={{
              agbText: t('subscriptions.AGB'),
            }}
            components={[
              <MuiLink
                key="terms"
                href={t('app.TACLink')}
                rel="noopener noreferrer"
                target="_blank"
              >
                {t('signup.termsAndConditions')}
              </MuiLink>,
            ]}
          />
        </Typography>
      </div>
      <div className={classes.onboardingTermsAndConditionsTerms}>
        <Field
          component={Checkbox}
          name="privacyPolicy"
          data-testid="privacyPolicy"
          disabled={disabled}
          className={classes.onboardingTermsAndConditionsCheckbox}
        />
        <Typography className={classes.onboardingTermsAndConditionsText}>
          <Trans
            i18nKey="signup.privacyPolicy"
            values={{
              privacyPolicyText: t('copyright.privacyPolicy'),
            }}
            components={[
              <MuiLink
                key="privacy"
                href={t('app.privacyPolicyLink')}
                rel="noopener noreferrer"
                target="_blank"
              >
                {t('copyright.privacyPolicy')}
              </MuiLink>,
            ]}
          />
        </Typography>
      </div>
      <div className={classes.onboardingTermsAndConditionsTerms}>
        <Field
          component={Checkbox}
          name="dpa"
          data-testid="dpa"
          disabled={disabled}
          className={classes.onboardingTermsAndConditionsCheckbox}
        />

        <Typography className={classes.onboardingTermsAndConditionsText}>
          <Trans
            i18nKey="signup.DPA"
            values={{
              dpa: t('signup.ADV'),
            }}
            components={[
              <MuiLink
                key="DPA"
                href={t('signup.ADVlink')}
                rel="noopener noreferrer"
                target="_blank"
              >
                {t('signup.ADV')}
              </MuiLink>,
            ]}
          />
        </Typography>
      </div>
    </FormControl>
  );
};
